import { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuthStore } from "@/stores/authStore";
import { Button } from "@/components/ui/button";

export function ProtectedRoute() {
  const { t } = useTranslation();
  const { user, status, error, fetchMe, clearError } = useAuthStore();
  const location = useLocation();

  useEffect(() => {
    if (status === "idle") void fetchMe();
  }, [status, fetchMe]);

  if (status === "idle" || status === "loading") {
    return (
      <div className="flex h-full items-center justify-center text-muted-foreground">
        Loading…
      </div>
    );
  }

  if (error === "server" && !user) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-4 p-6 text-center">
        <p className="max-w-md text-muted-foreground">
          {t("errors.serverUnavailable", {
            defaultValue: "The server is temporarily unavailable. Please try again.",
          })}
        </p>
        <Button
          onClick={() => {
            clearError();
            useAuthStore.setState({ status: "idle" });
            void fetchMe();
          }}
        >
          {t("common.retry", { defaultValue: "Retry" })}
        </Button>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (user.mustChangePassword && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }

  return <Outlet />;
}
